module.exports = __webpack_public_path__ + "img/after-sale-icon.dcf8d52e.png";